import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, {useState} from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import profile from "assets/images/bridge-logo.png";
import bg from "assets/images/background1.jpg";
import toastr from "toastr";
import axios from "axios";
import { TOAST_OPTIONS1, HRConfig2 } from "helpers/backend_helper";
import * as url from "helpers/apache_url";

const ForgetPasswordPage = props => {
  const history = useHistory()
  toastr.options = TOAST_OPTIONS1;
  	const [email, setEmail] = useState('')
    const submitEmail = () =>{
      const data = {email:email}
      axios.post(url.POST_PASSWORD_FORGET, JSON.stringify(data), HRConfig2).then((r)=>{
        if(r.request.status == '200'){
          toastr.success(r.data.message)
          history.push("/login")
        }else{
          toastr.error("Contact System Administrator")
        }
      }).catch((e)=>{console.log(e)})
    }

  return (
    <React.Fragment>
      <MetaTags>
      <title>Forgot Password | Bridge</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5" style={{position:'absolute', top:'0px', right:'0px', bottom:'0px',  left:'0px', margin:0, backgroundImage: "url(" + bg + ")", backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center',}}>
        <Container>
        <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
             
                <CardBody className="pt-0">
                  <div>
                  <Link to="/">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                      <img src={profile} alt="" className="img-fluid" height="80" />
                      </div>
                    </Col>
                  
                  </Row>
                    </Link>
                  </div>
                  
                  <div className="p-2">
                  <div className="alert alert-success text-center mb-4" role="alert">Enter your Email and instructions will be sent to you!</div>
          
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          type="email"
                          onChange={(e)=>{setEmail(e.target.value)}}
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="button"
                            onClick={(e)=>{submitEmail()}}
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>

                  </div>
               
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
            
              </div>
              </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
